module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0147.jpg?v=bbc30504";